import { RiskViewerKind } from "../../features/riskViewer/riskViewerSlice";
import { ForecastTime } from "../../app/forecastSurface";
import { moreRecent } from "../../features/surface/surfaceUtils";
import { RequestForecastPayload } from "../../services/riskSurface";
import { getAccessToken } from "../../app/auth";
import { DateTime } from "luxon";

export const TAU_LIMIT = 100;

/* If the latestSucceeded is false, then we just need to requery after the polling interval
     * If forecastTime is undefined, we haven't loaded anything OR we have a route selected, so nothing can be stale
     * If latestTime is more recent than forecastTime, then a new forecast is available
     */
export const isDataStale = (
    riskViewerState: RiskViewerKind,
    latestSucceeded: boolean,
    forecastTime: ForecastTime | undefined,
    latestTime: ForecastTime | undefined
) =>
{
    return (
        riskViewerState !== RiskViewerKind.TRIP_STATE &&
        latestSucceeded &&
        forecastTime &&
        moreRecent( forecastTime, latestTime )
    );
};

/* When the surface is first loading, both the latestForecastTime and window forecast time will be undefined.
     * Subsequntly, one or both will always be defined. useGetLatestForecastQuery periodically requeries to check if
     * new weather data is available. That query does not necessarily trigger an update to the forecast time, hence
     * We do not include the status of that query in isLoading.
     */
/* isFetching should be excluded -- we can be fetching data while the user is viewing
    the surface (e.g. with the play button on mobile), so we do not want to bring up the LoadingOverlay
    in that case*/
/* When the route metadata is already loaded, we make an optimistic assumption that the next route the user selects
    will not require a different forecast time. All multistart versions should generate with the same forecast time.
 */
export const isLoadingState = (
    isFetchingAvailableSurfaces: boolean,
    isFirstLoad: boolean,
    isFetchingRouteData: boolean,
    hasRouteMetadata: boolean,
) =>
{
    return (
        ( isFetchingAvailableSurfaces && !hasRouteMetadata ) ||
        isFirstLoad ||
        isFetchingRouteData
    );
};

export const fetchRiskSurface = async ( payload: RequestForecastPayload ): Promise<Response> =>
{
    const adjustedSurface = payload.surfaceName;
    const url = `${process.env.REACT_APP_API_BASE}/risksurface/${payload.time.date}/${payload.time.hour}/${adjustedSurface}?start=${payload.surface.start}&limit=${payload.surface.limit}`;

    return fetch( url, {
        headers: {
            "Accept": "application/json",
            "Authorization": `Bearer ${getAccessToken()}`
        }
    } );
};


export const formatRouteForecastTime = ( forecastTime: Date ) =>
{
    const routeForecastTimeMs = forecastTime.getTime();
    const routeForecastTimeDate = DateTime.fromMillis( routeForecastTimeMs ).setZone( "utc" );
    return {
        date: routeForecastTimeDate.toFormat( "yyyyMMdd" ),
        hour: routeForecastTimeDate.toFormat( "HH" ),
    };
};
